fx.ns("models", class ProductPrintPage extends  models.CreationElement {

	constructor(data)
	{
		super(data);
	}

  
	
});
